var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulbIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_2983)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E9BE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 5C8.49233 5 7 6.59893 7 8.57143C6.99957 9.07656 7.09934 9.57602 7.29272 10.0367C7.4861 10.4974 7.76866 10.9088 8.12167 11.2436C8.236 11.3521 8.30867 11.4739 8.335 11.5957L8.60667 12.8571H12.06L12.3317 11.5957C12.358 11.4743 12.4307 11.3521 12.545 11.2436C12.898 10.9088 13.1806 10.4974 13.3739 10.0367C13.5673 9.57602 13.6671 9.07656 13.6667 8.57143C13.6667 6.59893 12.1743 5 10.3333 5ZM11.9063 13.5714H8.76L8.859 14.0311C8.91833 14.3065 9.06306 14.5523 9.26956 14.7283C9.47606 14.9043 9.73214 15.0001 9.996 15H10.6703C10.9341 15 11.1901 14.9042 11.3966 14.7282C11.603 14.5522 11.7477 14.3065 11.807 14.0311L11.9063 13.5714Z",
    fill: "#FEFFE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_2983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulbIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bulbIcon.b75bc37a9912d38493e1c8723dc2f981.svg";